<!--- Componente PCMensajesInformativosPlanificacion  ---->
<!---
Descripción del componente y comportamiento:
---------------------------
- Muestra los mensajes informativos de una planificación

Eventos escuchados por el formulario:
-----------------------
-- XXXXXXX ->

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <div class="div-PCMensajesInformativosPlanificacion">
    <!-- Mensajes Informativos de la planificacion del pedido -->
    <div
      v-for="(mensaje, idx) in mensajesInformacion"

      :key="idx"
      class="div-mensajeInformacionDeLaPlanificacion"
    >
      <f7-row
        v-if="mensajesInformacion.length > 0"
        class="row-mensajeInformacionDeLaPlanificacion"
      >
        <f7-col width="5">
          <!-- <span class="oval-informacionAlertaRojo-14">!</span> -->
          <img
            alt="iconWrnnig"
            src="@/static/icons/ic_warning.svg"
          >
        </f7-col>
        <f7-col width="95">
          <span class="span-texto-azulOscuro-14-500"> {{ mensaje.TextoMensaje }}</span>
        </f7-col>
      </f7-row>

      <f7-row
        v-if="mensaje.AccionesRequeridas != null && mensaje.AccionesRequeridas.length > 0"
        class="row-opcionesDeSoluccionDeAccion"
      >
        <f7-col width="100">
          <span
            class="span-btn-solucionarAccion seleccionable"
            @click="SeleccionarSolucionMensaje(mensaje)"
          >
            {{ $t('production.informativeMessages.fix').toUpperCase() }}
          </span>
        </f7-col>
      </f7-row>
    </div>

    <UCConfirmation ref="actionConfirmacionAccionRequeridaAbierto" />
    <!-- <UCConfirmacionGH
      v-if="actionConfirmacionAccionRequeridaAbierto"
      plantilla="P2"
      :mostrar-centrado="true"
      :abierto="actionConfirmacionAccionRequeridaAbierto"
      titulo="CONFIRMAR ACCIÓN"
      :mensaje="mensajeSeleccionado.AccionesRequeridas[0].TextoMensaje"
      @Confirmar="actionConfirmacionAccionRequeridaAbierto = false; ConfirmarRealizarAccion()"
      @Cancelar="actionConfirmacionAccionRequeridaAbierto =false"
    /> -->
  </div>
</template>

<script>
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import eventBus from '@/js/event-bus'; // Import the EventBus.
import { Log } from '@/js/common/HIDebuggingSupport';

export default {
  name: 'PCMensajesInformativosPlanificacion',
  components: {
    UCConfirmation,

  },
  props: {
    mensajesInformacion: { type: Array, default: () => [] },
  },
  data() {
    return {
      // actionConfirmacionAccionRequeridaAbierto: false, // Controla la apertura del action de confirmación de las acciones requeridas.
      mensajeSeleccionado: null, // Controla el mensaje que se selecciono.
    };
  },

  methods: {
    /** ** Método SeleccionarSolucionMensaje */
    SeleccionarSolucionMensaje(objMensaje) {
      Log(this, this.SeleccionarSolucionMensaje.name);
      this.mensajeSeleccionado = objMensaje;
      this.$refs.actionConfirmacionAccionRequeridaAbierto.create(
        this.$t('production.informativeMessages.confirm').toUpperCase(),
        this.mensajeSeleccionado.AccionesRequeridas[0].TextoMensaje,
        this.ConfirmarRealizarAccion(),
      );
      this.$refs.actionConfirmacionAccionRequeridaAbierto.show();
    },

    /** ** Método ConfirmarRealizarAccion */
    ConfirmarRealizarAccion() {
      Log(this, this.ConfirmarRealizarAccion.name);
      const objAccion = this.mensajeSeleccionado.AccionesRequeridas[0];
      eventBus.emit(String(objAccion.RutinaEjecucion));
      this.$emit(String(objAccion.RutinaEjecucion));
    },
  },
};
</script>

<style scoped>
.div-mensajeInformacionDeLaPlanificacion {
  background: #f2c0c0;
  padding: 10px;
}

.row-opcionesDeSoluccionDeAccion {
  text-align: end;
  margin-top: 10px;
  margin-right: 10px;
}

.span-btn-solucionarAccion {
  color: #009ba6 !important;
  font-size: 18px;
  font-weight: 500;
}

.row-mensajeInformacionDeLaPlanificacion {
  margin-top: 10px;
}
</style>
